import type { TranslationInterface } from '.';

export const KoreanLanguage: TranslationInterface = {
  write_a_message_placeholder: '메시지를 입력하세요...',
  your_issue_has_been_resolved: '문제가 해결되었습니다!',
  new_conversation: '새 대화',
  welcome_screen_title: '고객 지원 채팅에 오신 것을 환영합니다',
  welcome_screen_description:
    '도움을 드리기 위해 여기 있습니다! 대화를 시작해 주시면 가능한 한 빨리 연락드리겠습니다.',
  your_name_placeholder: '이름',
  your_email_placeholder: '이메일 주소',
  start_chat_button: '상담원과 대화',
  start_chat_button_loading: '연결 중...',
  i_need_more_help: '추가 도움이 필요합니다',
  this_was_helpful: '도움이 되었습니다',
  optional: '선택 사항',
  no_conversations_yet: '아직 대화가 없습니다',
  back_to_conversations: '대화 목록으로 돌아가기',
  closed_conversations: '종료된 대화',
  csat_title: '대화는 어떠셨나요?',
  csat_submitted_title: '대화를 다음과 같이 평가했습니다',
  csat_feedback_placeholder: '더 알려주세요... (선택 사항)',
  follow_up_placeholder: '이어서 질문…',
  companion_layout_label: '레이아웃',
  companion_layout_floating: '플로팅',
  companion_layout_sidebar: '사이드바',
  companion_layout_fullscreen: '전체 화면',
  companion_close: '닫기',
  companion_history: '대화 기록',
  companion_expand_chat: '채팅 펼치기',
  companion_sidebar_dock_label: '도킹',
  companion_sidebar_side_label: '위치',
  companion_sidebar_left: '왼쪽',
  companion_sidebar_right: '오른쪽',
  companion_resize_chat: '채팅 크기 조절',
  scroll_to_bottom: '맨 아래로 스크롤',
  thinking: '생각 중…',
  running: '실행 중…',
  steps: '단계',
  step_arguments: '인수',
  step_result: '결과',
  attach_files: '이미지, 동영상, PDF 또는 스프레드시트 첨부(최대 크기 25 MB)',
  mark_page_active:
    '페이지에서 표시할 항목을 클릭하세요 — 취소하려면 Esc를 누르세요',
  mark_page: '질문할 페이지의 항목을 표시하세요',
  stop_response: '응답 중지',
  copy_reply: '답변 복사',
  mentions_empty: '일치하는 항목 없음',
  copied: '복사됨',
  send_message: '메시지 보내기',
  upload_failed: '업로드 실패: {error}',
  remove_attachment: '첨부 파일 삭제',
  json_no_items: '항목 없음',
  json_no_data: '데이터 없음',
  json_no_chart_data: '차트 데이터 없음',
  json_unsupported: '지원되지 않음: {type}',
  json_see_less: '간단히 보기',
  json_phone_agent: '전화 상담원',
  json_phone_agent_test: '웹에서 테스트',
  page_context_remove: '페이지 컨텍스트 제거',
  json_see_more: '{count}개 더 보기',
  queued_label: '{count} 대기 중',
  remove_queued_message: '대기열에서 메시지 삭제',
  send_queued_now: '대기 중인 메시지 지금 보내기',
  turn_failed_message: '문제가 발생하여 답변이 도착하지 않았습니다.',
  turn_failed_retry: '다시 시도',
  page_mark_hint: '표시할 항목을 클릭하세요',
  page_mark_escape: 'Esc',
  page_mark_shape_box: '상자',
  page_mark_shape_circle: '원',
  page_mark_shape_arrow: '화살표',
  page_mark_shape_bracket: '괄호',
  page_mark_shape_underline: '밑줄',
  page_mark_shape_highlight: '강조',
  page_mark_shape_strike_through: '취소선',
  page_mark_shape_crossed_off: 'X표',
  page_mark_shape_aria: '표시 모양: {shape}',
  page_mark_note_placeholder: '메모 추가…(Enter로 첨부)',
  page_mark_attach: '표시 첨부',
  page_mark_remove: '{label} 삭제',
  page_mark_region: '표시된 영역',
  page_mark_default_message: '이건 무엇인가요?',
  file_rejected: '지원되지 않는 파일 형식이거나 파일이 너무 큽니다.',
  dictate: '받아쓰기',
  stop_dictation: '받아쓰기 중지',
  dictation_mic_blocked: '받아쓰기를 하려면 마이크 접근을 허용하세요',
  dictation_unavailable: '지금은 받아쓰기를 사용할 수 없습니다',
  questions_back: '뒤로',
  questions_next: '다음',
  questions_send: '보내기',
  questions_type_answer: '직접 입력할게요',
  questions_answer_placeholder: '답변을 입력하세요…',
  close_conversation_title: '대화 종료',
  close_conversation_description: '이 대화를 종료하시겠습니까?',
  close_conversation_cancel: '아니요',
  close_conversation_confirm: '예',
  dialog_close: '닫기',
  zoom_in: '확대',
  zoom_out: '축소',
  reset_zoom: '확대/축소 초기화',
  support_chat_aria_label: '고객 지원 채팅',
};
